const ITEMS = [
  [
    {
      title: '20+ years',
      description: 'helping people get rid of debt',
      imageURL: '/next-assets/facts/top-company/a.png',
    },
    {
      title: '$20 billion+',
      description: 'in debt settled from 5 million+ accounts',
      imageURL: '/next-assets/facts/top-company/b.png',
    },
    {
      title: '1 million+',
      description: 'clients served since 2002',
      imageURL: '/next-assets/facts/top-company/c.png',
    },
  ],
  [
    {
      title: '1,000+',
      description: 'experts working for you every day',
      imageURL: '/next-assets/facts/top-company/d.png',
    },
    {
      title: '4,000+',
      description: 'creditors we negotiate with',
      imageURL: '/next-assets/facts/top-company/e.png',
    },
    {
      title: '200,000+',
      description: 'active clients',
      imageURL: '/next-assets/facts/top-company/f.png',
    },
  ],
]

export const defaultValues = {
  title: "America's top debt relief company",
  items: ITEMS,
  bottomText: [
    'Statistics reflect the results of the clients we and our affiliates have served since 2002 (as of January 2025).',
  ],
}
